import $ from "jquery";

export const contestsHandlers = () => {
    if(window.location.href.indexOf('rules')!==-1){
        $('#rules-button').click();
    }
};
